import { createContext, useContext } from 'react'
import type { Capability, Membership, MembershipsResponse } from '@/api/pending'
import type { Section } from './sections'

export interface Access {
  me: MembershipsResponse
  condoId: number
  membership: Membership
  capabilities: ReadonlySet<Capability>
  /** Sections this person can open here (capabilities ∩ feature flags). */
  sections: Section[]
  roleLabel: string
  /** Every condominium this person can manage, for the switcher. */
  contexts: Membership[]
}

export const AccessContext = createContext<Access | null>(null)

export function useAccess(): Access {
  const ctx = useContext(AccessContext)
  if (!ctx) throw new Error('useAccess must be used inside <AccessProvider>')
  return ctx
}
